import createLinkApp from '@infotech/energy-link-front-core'
import journalModuleConfig from 'modules/journalModule'
import reportModule from 'modules/reportModule'

createLinkApp({
  journalModuleConfig,
  extensions: [
    reportModule,
  ],
})
